import React, { useState } from "react";
import axios from "axios"; // (currently unused, keep if you'll use later)
import { baseurl } from "../../config/url"; // (currently unused here)
import Address from "./address"; // (currently unused here)

function BillingForm({ shippingCost, displayRazorpay, cart, submitOtherPayment }) {
  const [showOtherPayment, setShowOtherPayment] = useState(false);
  const [otherPaymentDetails, setOtherPaymentDetails] = useState({
    method: "",
    bankName: "",
    transactionId: "",
    ifscCode: "",
    accountNumber: "",
    amount: "",
  });

  // Safely pick only valid items (with productId)
  const validItems = (cart?.items || []).filter(
    (item) => item && item.productId
  );

  // If no valid items, show empty summary
  if (!validItems.length) {
    return (
      <div className="basis-[35%] bg-white p-8 rounded-lg shadow-lg border border-gray-200 max-h-fit">
        <h3 className="text-3xl font-extrabold mb-6 text-gray-800 tracking-tight">
          Order Summary
        </h3>
        <p className="text-gray-500 text-center">Your cart is empty.</p>
      </div>
    );
  }

  // Safely calculate totals
  const itemsTotal = validItems.reduce((total, item) => {
    const price = Number(item.productId?.price) || 0;
    const qty = Number(item.quantity) || 1;
    return total + price * qty;
  }, 0);

  const taxes = validItems.reduce((totalTax, item) => {
    const price = Number(item.productId?.price) || 0;
    const qty = Number(item.quantity) || 1;
    const gst = Number(item.productId?.gstNumber) || 0;
    return totalTax + price * qty * (gst / 100);
  }, 0);

  const safeShipping = Number(shippingCost) || 0;
  const grandTotal = itemsTotal + taxes + safeShipping;

  return (
    <div className="basis-[35%] bg-white p-8 rounded-lg shadow-lg border border-gray-200 max-h-fit">
      <h3 className="text-3xl font-extrabold mb-6 text-gray-800 tracking-tight">
        Order Summary
      </h3>

      <div className="space-y-4">
        {/* Items */}
        <div className="space-y-2">
          {validItems.map((item, index) => {
            const id = item.productId?._id || item._id || index;
            const name = item.productId?.name || "Product";
            const price = Number(item.productId?.price) || 0;
            const qty = Number(item.quantity) || 1;
            const gst = Number(item.productId?.gstNumber) || 0;

            const lineTotal = price * qty;
            const lineGst = lineTotal * (gst / 100);

            return (
              <div key={id} className="space-y-1">
                <div className="flex justify-between items-center">
                  <span className="text-lg font-medium text-gray-500">
                    {name} (x{qty})
                  </span>
                  <span className="text-lg font-semibold text-gray-900">
                    ₹{lineTotal.toFixed(2)}
                  </span>
                </div>
                <div className="flex justify-between items-center">
                  <span className="text-base text-gray-500">
                    GST ({gst}%):
                  </span>
                  <span className="text-base font-semibold text-gray-700">
                    ₹{lineGst.toFixed(2)}
                  </span>
                </div>
              </div>
            );
          })}
        </div>

        <hr className="border-t border-gray-300 my-4" />

        {/* Totals */}
        <div className="flex justify-between items-center">
          <span className="text-lg font-medium text-gray-500">Items Total</span>
          <span className="text-lg font-semibold text-gray-900">
            ₹{itemsTotal.toFixed(2)}
          </span>
        </div>

        <div className="flex justify-between items-center">
          <span className="text-lg font-medium text-gray-500">Total Tax</span>
          <span className="text-lg font-semibold text-gray-900">
            ₹{taxes.toFixed(2)}
          </span>
        </div>

        <div className="flex justify-between items-center">
          <span className="text-lg font-medium text-gray-500">Shipping</span>
          <span className="text-lg font-semibold text-gray-900">
            ₹{safeShipping.toFixed(2)}
          </span>
        </div>

        <div className="flex justify-between items-center font-bold">
          <span className="text-2xl text-gray-800">Total</span>
          <span className="text-2xl text-green-600">
            ₹{grandTotal.toFixed(2)}
          </span>
        </div>

        <hr className="border-t border-gray-300 my-4" />

        {/* Payment Buttons */}
        <button
          className="w-full bg-blue-600 text-white py-4 rounded-lg font-bold text-lg shadow-lg hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 transition duration-150"
          onClick={() => displayRazorpay(Math.round(grandTotal))}
        >
          Checkout
        </button>

        <button
          className="w-full bg-gray-500 text-white py-4 rounded-lg font-bold text-lg shadow-lg hover:bg-gray-600 focus:outline-none focus:ring-4 focus:ring-gray-300 transition duration-150"
          onClick={() => setShowOtherPayment(true)}
        >
          Other Payment
        </button>
      </div>

      {/* Other Payment Modal */}
      {showOtherPayment && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg shadow-lg w-full sm:w-4/5 lg:w-1/2 max-h-[90vh] overflow-auto">
            <h3 className="text-xl font-semibold mb-4">Other Payment</h3>

            <form className="space-y-4">
              <select
                value={otherPaymentDetails.method}
                onChange={(e) =>
                  setOtherPaymentDetails((prev) => ({
                    ...prev,
                    method: e.target.value,
                  }))
                }
                className="p-3 border rounded w-full"
              >
                <option value="">Select Payment Method</option>
                <option value="IMPS">IMPS</option>
                <option value="NEFT">NEFT</option>
                <option value="RTGS">RTGS</option>
                <option value="DD">DD</option>
                <option value="CHECK">Cheque</option>
              </select>

              <input
                type="number"
                placeholder="Amount"
                value={otherPaymentDetails.amount}
                onChange={(e) =>
                  setOtherPaymentDetails((prev) => ({
                    ...prev,
                    amount: e.target.value,
                  }))
                }
                className="p-3 border rounded w-full"
              />

              <input
                type="text"
                placeholder="Bank Name"
                value={otherPaymentDetails.bankName}
                onChange={(e) =>
                  setOtherPaymentDetails((prev) => ({
                    ...prev,
                    bankName: e.target.value,
                  }))
                }
                className="p-3 border rounded w-full"
              />

              <input
                type="text"
                placeholder="Transaction ID"
                value={otherPaymentDetails.transactionId}
                onChange={(e) =>
                  setOtherPaymentDetails((prev) => ({
                    ...prev,
                    transactionId: e.target.value,
                  }))
                }
                className="p-3 border rounded w-full"
              />

              <input
                type="text"
                placeholder="IFSC Code"
                value={otherPaymentDetails.ifscCode}
                onChange={(e) =>
                  setOtherPaymentDetails((prev) => ({
                    ...prev,
                    ifscCode: e.target.value,
                  }))
                }
                className="p-3 border rounded w-full"
              />

              <input
                type="number"
                placeholder="Account Number"
                value={otherPaymentDetails.accountNumber}
                onChange={(e) =>
                  setOtherPaymentDetails((prev) => ({
                    ...prev,
                    accountNumber: e.target.value,
                  }))
                }
                className="p-3 border rounded w-full"
              />

              <button
                className="w-full bg-green-600 text-white py-3 rounded-lg font-bold hover:bg-green-700"
                onClick={(e) => {
                  e.preventDefault();
                  submitOtherPayment(otherPaymentDetails);
                }}
              >
                Submit
              </button>

              <button
                className="w-full bg-gray-500 text-white py-3 rounded-lg font-bold hover:bg-gray-600"
                onClick={() => setShowOtherPayment(false)}
              >
                Cancel
              </button>
            </form>

            {/* Bank Details */}
            <div className="mt-6">
              <h4 className="text-lg font-semibold">Bank Details</h4>
              <p>
                <strong>Bank Name:</strong> HDFC Bank
                <br />
                <strong>Branch:</strong> New Panvel
                <br />
                <strong>Account Name:</strong> OGCS Private Limited
                <br />
                <strong>Account No:</strong> 50200084105798
                <br />
                <strong>IFSC Code:</strong> HDFC0000256
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BillingForm;
